import React from "react"
import {useTranslation} from "react-i18next"
import {IonAccordion, IonInput, IonItem, IonLabel} from "@ionic/react"

import User from "@customTypes/User"
import {usePeople as useItems} from "../../../contexts/PersonContext"
import {AuthType} from "@customTypes/Auth"

interface props {
    authUserInfo:      AuthType | undefined | null
    formData:          User
    item:              User | undefined
    updateFormHandler: any
}


const AccordionLimits: React.FC<props> = ({authUserInfo, formData, item, updateFormHandler}) => {

    const { t } = useTranslation()
    const { inProgress } = useItems()

    const calcPossibleMaxKeys = (): number => {
        if (item) {
            return (authUserInfo?.user.counts?.keysAvailable || 0) + (item?.maxKeys || 0)
        }

        return authUserInfo?.user.counts?.keysAvailable || 0
    }

    const calcPossibleMaxUsers = (): number => {
        if (item) {
            return (authUserInfo?.user.counts?.usersAvailable || 0) + (item?.maxUsers || 0)
        }

        return authUserInfo?.user.counts?.usersAvailable
            ? authUserInfo?.user.counts?.usersAvailable - 1
            : 0
    }

    const maxKeysLabel = () => {
        let label = t('users.form.max_keys') as string

        return label + ' (' + t('common.available') + ' ' + calcPossibleMaxKeys() + ')'
    }

    const maxUsersLabel = () => {
        let label = t('users.form.max_users') as string

        return label + ' (' + t('common.available') + ' ' + calcPossibleMaxUsers() + ')'
    }

    return (
        <IonAccordion toggleIconSlot="start" value="limits">
            <IonItem className="bc-accordion" slot="header">
                <IonLabel>{t('users.form.limits')}</IonLabel>
            </IonItem>
            <IonItem slot="content">
                <IonInput name="max_keys" label={maxKeysLabel()} labelPlacement="stacked"
                          clearInput={true}
                          disabled={inProgress}
                          value={formData.maxKeys}
                          inputmode="numeric"
                          min={0}
                          max={calcPossibleMaxKeys()}
                          placeholder={t('users.form.max_keys_placeholder') as string}
                          type="number"
                          onIonChange={updateFormHandler('maxKeys')}
                />
            </IonItem>
            <IonItem slot="content">
                <IonInput name="max_users" label={maxUsersLabel()} labelPlacement="stacked"
                          clearInput={true}
                          disabled={inProgress}
                          value={formData.maxUsers}
                          inputmode="numeric"
                          min={0}
                          max={calcPossibleMaxUsers()}
                          placeholder={t('users.form.max_users_placeholder') as string}
                          type="number"
                          onIonChange={updateFormHandler('maxUsers')}
                />
            </IonItem>
        </IonAccordion>
    )
}

export default AccordionLimits